import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './lib/auth-context'
import Landing from './pages/Landing'
import Login from './pages/Login'
import AppShell from './components/AppShell'
import Dashboard from './pages/Dashboard'
import Threads from './pages/Threads'
import Schedule from './pages/Schedule'
import Engagement from './pages/Engagement'
import Settings from './pages/Settings'
import Topics from './pages/Topics'
import BookmarkletIngest from './pages/BookmarkletIngest'

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/app"
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="threads" element={<Threads />} />
          <Route path="schedule" element={<Schedule />} />
          <Route path="engagement" element={<Engagement />} />
          <Route path="topics" element={<Topics />} />
          <Route path="bookmarklet/ingest" element={<BookmarkletIngest />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

function RequireAuth({ children }: { children: JSX.Element }) {
  const { me, loading } = useAuth()
  const location = useLocation()
  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        Loading…
      </div>
    )
  }
  if (!me) return <Navigate to="/login" replace state={{ from: location }} />
  return children
}
